module.exports = __webpack_public_path__ + "static/assets/bf47c8a721ee233b20066e9cff0d7cea.png";